export { AccredibleLanguageSelectorComponent } from './lib/component/language-selector.component';
